import React, {Component} from 'react';
import PropTypes from 'prop-types';

class BoxedText extends Component {
    render() {
        return (
            <div style={{width: this.props.width, height: this.props.height,backgroundColor:this.props.backgroundColor}} className={"flex flex-row items-center justify-center rounded-md p-3 border-2 border-gray-200 bg-white "}>
                <div className={"font-medium"}> {this.props.text} </div>
            </div>
        );
    }
}

BoxedText.propTypes = {
    text: PropTypes.string,
    width:PropTypes.string,
    height: PropTypes.string,
    backgroundColor: PropTypes.string,

};

export default BoxedText;